import React from 'react';
import PageContainer from "../../../hoc/PageContainer";

const BeOurMember = () => (
    <div>
        <PageContainer page={"BeOurMember"}>
            <h1 className="AboutUsTitle">BE OUR MEMBERS</h1>
            <div className="AboutUsText">
                The heart of Rotary is our members, dedicated people who share a passion for community service and friendship. Rotary members share ideas, make plans, hear from the community and catch up with friends during club programs that create impact to our community.
                <br/>
                <br/>
                <b>MEMBERS FROM ALL WALKS OF LIFE</b>
                <br/>
                <br/>
                While Rotary clubs are grounded in the same values, no two are the same, because each community has its own unique needs. Since inception in 2009, Rotary Club of Central have attracted members from a wide range of professions, spanning from retail banking , corporate finance, wealth management, construction industry, accounting, business aviation, legal and compliance, architecture, medical, fast moving consumer goods, tertiary education , public service, music education, civil engineering, food and beverage, IT management to interior design…
                <br/>
                <br/>
                These diverse qualities allow a wide range of communication and idea exchange to take place at club level to strengthen our connections to friends and neighbors and our commitment to improving lives.
                <br/>
                <br/>
                <b>WHAT ARE THE BENEFITS</b>
                <br/>
                <br/>
                Becoming a Rotary member connects you with a vibrant group of professionals who share your drive to give back. Through regular meetings and events, you’ll:
                <br/>
                <br/>
                <ul>
                    <li>Discuss your community’s needs and develop creative ways to meet them</li>
                    <li>Connect with other leaders who are changing the world</li>
                    <li>Expand your leadership and professional skills</li>
                    <li>Catch up with good friends and meet new one</li>
                    <li>Can visit Rotary clubs worldwide as club ambassadors</li>
                    <li>Receive monthly Rotary magazine to keep updated of global Rotary news</li>
                </ul>
                Other benefits of membership include:
                <br/>
                <br/>
                <ul>
                    <li>Rotary Global Rewards , our member benefits program, which offers discounts on products and services, It’s Rotary’s way of helping our members spend less so they can do more.</li>
                    <li>The Rotary International Convention is our biggest event of the year. Rotary members from more than 130 countries meet at the convention each year to celebrate our successes and make plans for the future.</li>
                    <li>Rotary Fellowships give members the chance to join a group of people who share similar interests, hobbies, or vocations. Some groups use their fellowship to make a positive influence.</li>
                    <li>Rotarian Action Groups unite Rotary members, family members, program participants and alumni who share their expertise in particular fields by collaborating with clubs and districts on projects.</li>
                </ul>
                <br/>
                <br/>
                <b>WHAT'S EXPECTED OF ME</b>
                <br/>
                <br/>
                <ul>
                    <li>Pay club dues</li>
                    <li>Attend meetings and events</li>
                    <li>Wear Rotary pins at all Rotary meetings/events</li>
                    <li>Use your professional skills and talents to make a difference</li>
                </ul>
                <br/>
                <br/>
                <b>WHAT'S NEXT</b>
                <br/>
                <br/>
                Membership to a Rotary Club is by invitation. Please contact our membership director to find out more details.
            </div>
        </PageContainer>
    </div>
);

export default BeOurMember;
